import * as Yup from "yup";


export const addBrandSchema = () => {
    return Yup.object().shape({
        brandName: Yup.string()
            .required('Brand name is required')
            .min(3, 'Brand name must be at least 3 characters'),

        logo_url: Yup.string()
            .url('Invalid URL format')
            .nullable(),

        description: Yup.string()
            .max(500, 'Description is too long')
            .nullable(),

        website: Yup.string()
            .url('Invalid URL format')
            .nullable(), // Allows field to be empty if not mandatory

    });
}

export const addStatesValidation = () => {
    return Yup.object({
        name: Yup.string()
            .trim()
            .required("*State name is required")
            .max(100, "*State name must be at most 100 characters"),

        country_id: Yup.mixed()
            .required("*Country is required"),

        state_code: Yup.string()
            .trim()
            .required("*State code is required")
            .max(3, "*State code must be at most 3 characters"),

    })
}


export const addCitiesValidation = () => {
    return Yup.object({
        name: Yup.string()
            .trim()
            .required("*State name is required")
            .max(100, "*State name must be at most 100 characters"),
        city_code: Yup.string()
            .trim()
            .required("*City code is required")
            .max(3, "*City code must be at most 3 characters"),


        state_id: Yup.mixed()
            .required("*State is required"),

        country_id: Yup.string()
            .trim()
            .required("*Country is required")
    })
}


